// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***************************************************************
 ******************** FMS custom variables *********************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables before ****************
 **************************************************************/
/***************************************************************
 *************** Overriding bootstrap variables after ****************
 **************************************************************/
/* Alerts */
/* Badges */
/* Modals */
/* Dropdowns */
body {
  width: 100vw;
  height: 100vh;
  overflow: auto;
}

/* Bootstrap overrides */
.table thead th {
  border: none;
}

table.fixed-layout {
  table-layout: fixed;
}

td.vertical-align-middle {
  vertical-align: middle !important;
}

h1 {
  font-family: "Noto Sans";
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 0;
}

h2 {
  font-family: "Noto Sans";
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 0;
}

h3 {
  font-family: "Noto Sans";
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 0;
}

h4 {
  font-family: "Noto Sans";
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0;
}

h5 {
  font-family: "Noto Sans";
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0;
}

h6 {
  font-family: "Noto Sans";
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
}

.btn {
  font-weight: bold;
  border-width: 2px;
}

a.btn {
  font-size: 1rem;
}

.btn-secondary {
  background-color: #8291ae;
  border-color: #8291ae;
}

.btn-outline-secondary {
  color: #8291ae;
  border-color: #8291ae;
}

a.link,
a.link:not([href]):not([tabindex]) {
  font-size: 14px;
  font-weight: bold;
  color: #1161be;
  cursor: pointer;
}

a.link-danger {
  font-size: 14px;
  font-weight: bold;
  color: #f64540 !important;
  cursor: pointer;
}

a.link:hover {
  color: #0056b3;
}

a.in-text-link {
  font-size: 14px !important;
  font-weight: normal !important;
  text-decoration: none !important;
  color: #1161be;
  cursor: pointer;
}

.bs-datepicker.archived-task-range {
  right: 126px;
}

.bs-datepicker.report-range {
  top: 2px;
  left: 180px;
}

tabset {
  background-color: #fff;
}
tabset ul.nav-tabs {
  background-color: #fff;
}
tabset ul.nav-tabs a.nav-link {
  border-width: 0 0 2px 0;
  border-bottom: 2px solid transparent;
  color: rgba(0, 0, 0, 0.87);
  font-family: "Noto Sans";
  font-size: 18px;
  font-weight: bold;
  min-width: 160px;
  padding: 7px 24px;
  text-align: center;
}
tabset ul.nav-tabs a.nav-link.active,
tabset ul.nav-tabs a.nav-link:hover {
  /*border-bottom: 2px solid rgba(0, 0, 0, .87);*/
}
tabset ul.nav-tabs a.nav-link.active {
  background-color: #fff;
  color: #1161be;
  border-bottom: 2px solid #1161be;
}

.bck-white {
  background: #fff;
}

.bck-gray {
  background: #f7f8fc;
}

.bck-blue {
  background: #1161be;
  color: #fff;
}

.bck-blue-light {
  background: #e1eefe;
}

.cursor-pointer {
  cursor: pointer;
}

.white-box {
  background-color: #fff;
  padding: 1.5rem;
}

.blue-box {
  background-color: #e1eefe;
  padding: 1rem 1.5rem;
}

.light-gray-box {
  background-color: #f7f8fc;
  padding: 0.75rem;
}

.card-body .main-container {
  padding: 34px;
}

input.rtl {
  direction: rtl;
}

.flex-grow {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.no-flex-shrink {
  flex-shrink: 0;
}

.navbar {
  z-index: 100;
}

.pull-right {
  float: right;
}

.pull-left {
  float: left;
}

.wide-modal {
  max-width: 60vw !important;
}

.remove-icon {
  color: #f64540;
  cursor: pointer;
}

.disabled-icon {
  color: #8291ae;
}

.input-group.with-icon input.form-control {
  border-right-width: 0;
}
.input-group.with-icon .input-group-text {
  background-color: #fff;
}

.badge.badge-button {
  position: absolute;
  top: -10px;
  right: -10px;
  display: block;
  min-width: 20px;
  height: 20px;
  line-height: 20px;
  padding: 0 0.4em;
}

a.disabled {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.35;
}

.task-tags {
  height: 18px;
  line-height: 0;
  padding: 0;
}

.task-tag {
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  padding: 0 8px;
  border-radius: 9px;
  margin-right: 5px;
}

.task-tag.category {
  color: #8291ae;
  background-color: #e6e9f0;
}

.task-tag.type {
  color: #151b26;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-decoration-underline {
  text-decoration: underline;
}

[ng-reflect-router-link] {
  cursor: pointer;
}

i-feather.blue-icon {
  color: #1161be;
  cursor: pointer;
}

i-feather.white-icon {
  color: #fff;
  cursor: pointer;
}

.modal-dialog.modal-image {
  width: auto;
  max-width: initial;
}
.modal-dialog.modal-image .modal-content {
  width: auto;
  margin-left: auto;
  margin-right: auto;
  border-radius: 0;
}

.float-right {
  float: right;
}

.color-yellow {
  color: #fbcd1e;
}

@keyframes loading-indicator {
  to {
    transform: rotate(360deg);
  }
}
.loading-indicator {
  position: relative;
}

.loading-indicator .blocker {
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: progress;
  background-color: rgba(255, 255, 255, 0.7);
}

.loading-indicator::after {
  content: "";
  box-sizing: border-box;
  position: absolute;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: #07d;
  border-bottom-color: #07d;
  animation: 0.6s linear infinite loading-indicator;
  z-index: 2;
}

.loading-indicator.for-dropdown::after {
  bottom: 6px;
  right: 6px;
  width: 20px;
  height: 20px;
  background-color: #fff;
}

.loading-indicator.for-element::after {
  top: calc(50% - 15px);
  left: calc(50% - 15px);
  width: 30px;
  height: 30px;
  background-color: transparent;
}

.star-icon, .star-icon::before {
  font-size: 1em !important;
  color: #8291ae !important;
}

.notifier__container {
  position: absolute;
  top: 0;
  left: 0;
}

table.table {
  margin-bottom: initial;
}

.sidenav-content {
  height: 100%;
}
.sidenav-content .sidenav-body {
  padding: 25px 20px;
  height: calc(100% - 60.5px);
  overflow-y: auto;
}
.sidenav-content .sidenav-footer {
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  padding: 12px 20px;
}

/* structure components styling */
.Country-list {
  border-right: solid 1px #e1eefe;
  height: calc(100vh - 215px);
}

.Country-item {
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 14px;
  font-weight: bold;
  box-shadow: 0 -1px 0 0 #e1eefe;
}

.Country-header {
  font-size: 18px;
  padding-top: 20px;
  padding-bottom: 20px;
  font-weight: bold;
}

.country-detail-item {
  color: #fff;
  padding-left: 10px;
  margin-top: 20px;
  padding-top: 8px;
  background: #1161be;
  height: 40px;
  font-size: 14px;
  font-weight: bold;
}

.governorate-detail-item {
  padding-left: 10px;
  margin-top: 10px;
  padding-top: 8px;
  color: #1161be;
  background: #bee7ff;
  height: 40px;
  font-size: 14px;
  font-weight: bold;
}

.district-detail-item {
  padding-left: 10px;
  margin-top: 10px;
  padding-top: 8px;
  color: #1161be;
  background: #e1eefe;
  height: 40px;
  font-size: 14px;
  font-weight: bold;
}

.unit-detail-item {
  padding-left: 10px;
  margin-top: 10px;
  padding-top: 8px;
  background: #f7f8fc;
  height: 40px;
  font-size: 14px;
  font-weight: bold;
}

ul.org-unit {
  list-style: none;
}

ul.org-unit li::before {
  content: " ";
  color: #1161be;
  font-size: 0px;
  /* font-weight: bold; */
  display: inline-block;
  position: relative;
  right: 35px;
  top: -3px;
  /* margin-left: 20em; */
  background: #1161be;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

ul.org-unit li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 16px;
  position: relative;
  display: block;
  left: -50px;
}

ul.org-unit > ul > li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 55px;
  position: relative;
  display: block;
  left: -90px;
}

ul.org-unit {
  margin-bottom: 0 !important;
}

.no-children {
  width: 32px;
  height: 30px;
}

ul.org-unit > ul > ul > li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 95px;
  position: relative;
  display: block;
  left: -130px;
}

ul.org-unit > ul > ul > ul > li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 135px;
  position: relative;
  display: block;
  left: -170px;
}

ul.org-unit > ul > ul > ul > ul > li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 175px;
  position: relative;
  display: block;
  left: -210px;
}

ul.org-unit > ul > ul > ul > ul > ul > li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 215px;
  position: relative;
  display: block;
  left: -250px;
}

ul.org-unit > ul > ul > ul > ul > ul > ul > li::after {
  content: " ";
  border-left: 1px solid #1161be;
  border-bottom: 1px solid #1161be;
  height: 50px !important;
  top: -62px;
  width: 255px;
  position: relative;
  display: block;
  left: -290px;
}

.nav-link.country-name {
  padding: 0;
}

.country-name-container {
  list-style-type: none;
  padding: 0;
}

.country-name-container a {
  color: white;
}

.country-name-container .nav-link {
  color: #292727;
}

.inv-request {
  background: #e1eefe;
  margin-bottom: 5px;
  padding-top: 7px;
  padding-bottom: 7px;
  box-shadow: 0 2px 4px 0 #f4f4f4;
}

.align-center {
  display: flex;
  align-items: center;
  font-family: "Noto Sans";
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
}

.item-delete {
  direction: rtl;
}

.buttons {
  margin-top: 10px;
  background: white;
  padding: 5px;
}

.white-box {
  padding-top: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/styles/_custom.scss","webpack://./src/app/tasks/task-view/task-inventory-requests/task-inventory-requests.component.scss"],"names":[],"mappings":"AACA;;+DAAA;AAwDA;;+DAAA;AAuBA;;+DAAA;AAgGA,WAAA;AAIA,WAAA;AAMA,WAAA;AAMA,cAAA;AC9LA;EACE,YAAA;EACA,aAAA;EACA,cAAA;ACYF;;ADTA,wBAAA;AAII;EACE,YAAA;ACSN;;ADJA;EACE,mBAAA;ACOF;;ADJA;EACE,iCAAA;ACOF;;ADJA;EACE,wBDwBgB;ECvBhB,eAAA;EACA,iBAAA;EACA,gBAAA;ACOF;;ADJA;EACE,wBDiBgB;EChBhB,eAAA;EACA,iBAAA;EACA,gBAAA;ACOF;;ADJA;EACE,wBDUgB;ECThB,eAAA;EACA,iBAAA;EACA,gBAAA;ACOF;;ADJA;EACE,wBDGgB;ECFhB,eAAA;EACA,iBAAA;EACA,gBAAA;ACOF;;ADJA;EACE,wBDJgB;ECKhB,eAAA;EACA,iBAAA;EACA,gBAAA;ACOF;;ADJA;EACE,wBDXgB;ECYhB,eAAA;EACA,iBAAA;EACA,gBAAA;ACOF;;ADJA;EACE,iBAAA;EACA,iBAAA;ACOF;;ADJA;EACE,eAAA;ACOF;;ADJA;EACE,yBDhES;ECiET,qBDjES;AEwEX;;ADJA;EACE,cDrES;ECsET,qBDtES;AE6EX;;ADJA;;EAEE,eAAA;EACA,iBAAA;EACA,cDjFS;ECkFT,eAAA;ACOF;;ADJA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;ACOF;;ADJA;EACE,cAAA;ACOF;;ADJA;EACE,0BAAA;EACA,8BAAA;EACA,gCAAA;EACA,cDpGS;ECqGT,eAAA;ACOF;;ADJA;EACE,YAAA;ACOF;;ADJA;EACE,QAAA;EACA,WAAA;ACOF;;ADJA;EACE,sBAAA;ACOF;ADLE;EACE,sBAAA;ACOJ;ADLI;EACE,uBAAA;EACA,oCAAA;EACA,0BAAA;EACA,wBDlFY;ECmFZ,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,iBAAA;EACA,kBAAA;ACMN;ADHI;;EAEE,+CAAA;ACKN;ADFI;EACE,sBAAA;EACA,cD3IK;EC4IL,gCAAA;ACIN;;ADCA;EACE,gBDxJU;AE0JZ;;ADCA;EACE,mBDjJe;AEmJjB;;ADCA;EACE,mBD1JS;EC2JT,WDjKU;AEmKZ;;ADCA;EACE,mBD7Je;AE+JjB;;ADCA;EACE,eAAA;ACEF;;ADCA;EACE,sBAAA;EACA,eAAA;ACEF;;ADCA;EACE,yBD1Ke;EC2Kf,oBAAA;ACEF;;ADCA;EACE,yBD5Ke;EC6Kf,gBAAA;ACEF;;ADEE;EACE,aAAA;ACCJ;;ADGA;EACE,cAAA;ACAF;;ADGA;EAEE,aAAA;EAEA,YAAA;EACA,eAAA;ACAF;;ADGA;EACE,cAAA;ACAF;;ADGA;EACE,YAAA;ACAF;;ADGA;EACE,YAAA;ACAF;;ADGA;EACE,WAAA;ACAF;;ADGA;EACE,0BAAA;ACAF;;ADGA;EACE,cDrMQ;ECsMR,eAAA;ACAF;;ADGA;EACE,cD7NS;AE6NX;;ADIE;EACE,qBAAA;ACDJ;ADIE;EACE,sBAAA;ACFJ;;ADMA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;ACHF;;ADMA;EACE,oBAAA;EACA,mBAAA;EACA,aAAA;ACHF;;ADMA;EACE,YAAA;EACA,cAAA;EACA,UAAA;ACHF;;ADMA;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;ACHF;;ADMA;EACE,cD3QS;EC4QT,yBAAA;ACHF;;ADMA;EACE,cAAA;ACHF;;ADMA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,eAAA;ACHF;;ADMA;EACE,cDtSS;ECuST,eAAA;ACHF;;ADMA;EACE,WDjTU;ECkTV,eAAA;ACHF;;ADOA;EACE,WAAA;EACA,kBAAA;ACJF;ADME;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;ACJJ;;ADQA;EACE,YAAA;ACLF;;ADSA;EACE,cDpTW;AE8Sb;;ADSA;EACE;IACE,yBAAA;ECNF;AACF;ADSA;EACE,kBAAA;ACPF;;ADUA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,0CAAA;ACPF;;ADUA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,sBAAA;EACA,yBAAA;EACA,iDAAA;EACA,UAAA;ACPF;;ADUA;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;ACPF;;ADUA;EACE,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;ACPF;;ADUA;EACE,yBAAA;EACA,yBAAA;ACPF;;ADUA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;ACPF;;ADUA;EACE,sBAAA;ACPF;;ADUA;EACE,YAAA;ACPF;ADSE;EACE,kBAAA;EACA,2BAAA;EACA,gBAAA;ACPJ;ADUE;EACE,0CAAA;EACA,kBAAA;ACRJ;;ADaA,iCAAA;AACA;EACE,+BAAA;EACA,2BAAA;ACVF;;ADaA;EACE,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;ACVF;;ADaA;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;ACVF;;ADaA;EACE,WDjbU;ECkbV,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBD/aS;ECgbT,YAAA;EACA,eAAA;EACA,iBAAA;ACVF;;ADaA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cDzbS;EC0bT,mBDvamB;ECwanB,YAAA;EACA,eAAA;EACA,iBAAA;ACVF;;ADaA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cDpcS;ECqcT,mBDnce;ECocf,YAAA;EACA,eAAA;EACA,iBAAA;ACVF;;ADcA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBD3ce;EC4cf,YAAA;EACA,eAAA;EACA,iBAAA;ACXF;;ADeA;EACE,gBAAA;ACZF;;ADeA;EACE,YAAA;EACA,cD7dS;EC8dT,cAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,uBAAA;EACA,mBDreS;ECseT,UAAA;EACA,WAAA;EACA,kBAAA;ACZF;;ADeA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;ACZF;;ADeA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;ACZF;;ADeA;EACE,2BAAA;ACZF;;ADeA;EACE,WAAA;EACA,YAAA;ACZF;;ADeA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;ACZF;;ADeA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;ACZF;;ADeA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;ACZF;;ADeA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;ACZF;;ADeA;EACE,YAAA;EACA,8BAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;ACZF;;ADeA;EACE,UAAA;ACZF;;ADeA;EACE,qBAAA;EACA,UAAA;ACZF;;ADeA;EACE,YAAA;ACZF;;ADeA;EACE,cAAA;ACZF;;AAllBA;EACE,mBFSe;EERf,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+BAAA;AAqlBF;;AAllBA;EACE,aAAA;EACA,mBAAA;EACA,wBFsCgB;EErChB,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAqlBF;;AAllBA;EACE,cAAA;AAqlBF;;AAllBA;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;AAqlBF;;AAllBA;EACE,yBAAA;AAqlBF","sourcesContent":["\n/***************************************************************\n ******************** FMS custom variables *********************\n **************************************************************/\n$fms-white: #fff;\n$fms-black: #000;\n\n$fms-gray-text: #252525;\n\n//primary\n$fms-blue: #1161be;\n//$fms-blue-dark: #00264f;\n$fms-blue-light: #e1eefe;\n$fms-gray-dark: #252525;\n$fms-gray: #8291ae;\n$fms-gray-light: #f7f8fc;\n\n// $fms-gray-tone: #f0f3f2;\n// $fms-gray-bg: #f9fbfc;\n// $fms-gray-border: #e9eef0;\n// $fms-link-color: #248cfc;\n$fms-green: #1ba953;\n$fms-green-light: #daf8e6;\n\n$fms-yellow: #fbcd1e;\n$fms-yellow-light: #fff4cb;\n//secondary\n\n\n$fms-blue-secondary: #bee7ff;\n\n$fms-purple: #ebe8fc;\n$fms-orange: #ff612c;\n$fms-red: #f64540;\n$fms-pink: #ff5b84;\n\n\n\n$fms-error: $fms-red;\n$fms-pending: $fms-yellow;\n$fms-positive: $fms-green;\n$fms-padding-x: 1.375rem;\n// $fms-grid-border-color: $fms-gray-light;\n// $fms-grid-color: $fms-gray-dark;\n// $fms-grid-header-background-color: $fms-white; //$fms-gray-light;\n// $fms-grid-row-even-background-color: $fms-white;\n// $fms-grid-row-hover-background-color:#E1F1F7;\n// $fms-grid-row-padding-y: 1.4rem; //original 1.5rem\n// $fms-checkbox-size: 1.25rem;\n// $fms-checkbox-size-sm: .875rem;\n// $fms-checkbox-size-lg: 1.875rem;\n$fms-font-family: 'Noto Sans';\n// $fms-font-family-medium: \"Graphik Medium\";\n// $fms-font-family-bold: \"Graphik Bold'\";\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables before ****************\n **************************************************************/\n\n\n$btn-disabled-opacity: .35;\n$input-btn-focus-box-shadow: none;\n$input-btn-active-box-shadow: none;\n$btn-box-shadow: none;\n$btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n\n$body-bg: $fms-gray-light;\n$body-color: $fms-gray-dark;\n\n\n\n@import 'node_modules/bootstrap/scss/functions';\n@import 'node_modules/bootstrap/scss/variables';\n\n\n\n\n/***************************************************************\n *************** Overriding bootstrap variables after ****************\n **************************************************************/\n\n$grid-breakpoints: (xs: 0,\nsm: 1px,\nmd: 2px,\nlg: 3px,\nxl: 100px);\n\n\n//Fonts\n$font-family-sans-serif: $fms-font-family;\n$font-family-base: $font-family-sans-serif;\n\n\n$link-color: $fms-blue;\n//$link-color-active: $fms-blue;\n\n$theme-colors: (\"primary\": $fms-blue,\n\"warning\": $fms-pending,\n\"danger\": $fms-red,\n\"info\": $fms-blue,\n\"success\": $fms-green);\n\n\n\n//Headings\n//$headings-font-family: $fms-font-family-medium;\n$headings-color: $fms-gray-dark;\n$headings-font-weight: bold;\n// $headings-margin-bottom: 1.5rem;\n// $h1-font-size: 2.44125rem;\n// $h2-font-size: 1.953125rem;\n// $h3-font-size: 1.563125rem;\n// $h4-font-size: 1.25rem;\n// $h1-line-height: 3.125rem; //fms var\n// $h2-line-height: 2.625rem; //fms var\n// $h3-line-height: 1.875rem; //fms var\n// $h4-line-height: 1.5rem; //fms var\n\n//Nav\n$navbar-padding-y: $spacer *  0.75;\n$navbar-padding-x: $spacer * 2;\n\n$navbar-light-color: $fms-gray-text;\n$navbar-light-hover-color: $link-hover-color;\n$navbar-light-active-color: $link-hover-color;\n$navbar-light-disabled-color: rgba($fms-gray-text, .3);\n\n\n//Card\n\n$card-cap-bg: $fms-white;\n$card-bg: $fms-gray-light;\n\n//Table\n\n$table-bg: $fms-white;\n$table-accent-bg: $fms-gray-light;\n$table-hover-bg: rgba($component-active-bg, .2);\n$table-active-bg:  rgba($component-active-bg, .3);\n\n//Small text\n// $small-font-size: 0.8125rem;\n// $small-line-height: 1.125rem; //bac var\n\n// Buttons + Forms\n\n//\n// $btn-padding-y: .575rem;\n// $btn-padding-y-lg: $btn-padding-y;\n// $btn-padding-x-sm: 1.25rem;\n// $btn-padding-y-sm: .40625rem;\n// $btn-border-radius: .3rem;\n// $btn-border-radius-lg: $btn-border-radius;\n// $btn-border-radius-sm: $btn-border-radius;\n// $input-color: $fms-gray-dark;\n// $input-border-radius: 0;\n// $input-border-radius-lg: $input-border-radius;\n// $input-border-radius-sm: $input-border-radius;\n// $input-border-color: $fms-gray;\n// $input-border-width: 0.0625rem; //1px\n\n// $input-padding-x: .75rem;\n// $input-padding-y: .938rem;\n// $form-group-margin-bottom: 2rem;\n\n//Paragrahs\n//$paragraph-margin-bottom: .5rem;\n\n//Cards\n// $card-border-color: $fms-gray-border;\n// $card-spacer-x: $fms-padding-x;\n\n\n/* Alerts */\n// $alert-padding-y: .5rem;\n// $alert-padding-x: .625rem;\n\n/* Badges */\n\n// $badge-padding-x: 1rem;\n// $badge-padding-y: .2rem;\n// $badge-border-radius: .25rem;\n\n/* Modals */\n// $modal-lg: 684px;\n// $modal-content-border-radius: 0;\n// $modal-backdrop-bg: $fms-blue-dark;\n// $modal-backdrop-opacity: .8;\n\n/* Dropdowns */\n//$dropdown-item-padding-x: .9375rem\n","@import \"variables\";\n\nbody {\n  width: 100vw;\n  height: 100vh;\n  overflow: auto;\n}\n\n/* Bootstrap overrides */\n\n.table {\n  thead {\n    th {\n      border: none;\n    }\n  }\n}\n\ntable.fixed-layout {\n  table-layout: fixed;\n}\n\ntd.vertical-align-middle {\n  vertical-align: middle !important;\n}\n\nh1 {\n  font-family: $fms-font-family;\n  font-size: 32px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\nh2 {\n  font-family: $fms-font-family;\n  font-size: 28px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\nh3 {\n  font-family: $fms-font-family;\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\nh4 {\n  font-family: $fms-font-family;\n  font-size: 18px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\nh5 {\n  font-family: $fms-font-family;\n  font-size: 16px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\nh6 {\n  font-family: $fms-font-family;\n  font-size: 14px;\n  font-weight: bold;\n  margin-bottom: 0;\n}\n\n.btn {\n  font-weight: bold;\n  border-width: 2px;\n}\n\na.btn {\n  font-size: 1rem;\n}\n\n.btn-secondary {\n  background-color: $fms-gray;\n  border-color: $fms-gray;\n}\n\n.btn-outline-secondary {\n  color: $fms-gray;\n  border-color: $fms-gray;\n}\n\na.link,\na.link:not([href]):not([tabindex]) {\n  font-size: 14px;\n  font-weight: bold;\n  color: $fms-blue;\n  cursor: pointer;\n}\n\na.link-danger {\n  font-size: 14px;\n  font-weight: bold;\n  color: $fms-red !important;\n  cursor: pointer;\n}\n\na.link:hover {\n  color: #0056b3;\n}\n\na.in-text-link {\n  font-size: 14px !important;\n  font-weight: normal !important;\n  text-decoration: none !important;\n  color: $fms-blue;\n  cursor: pointer;\n}\n\n.bs-datepicker.archived-task-range {\n  right: 126px;\n}\n\n.bs-datepicker.report-range {\n  top: 2px;\n  left: 180px;\n}\n\ntabset {\n  background-color: #fff;\n\n  ul.nav-tabs {\n    background-color: #fff;\n\n    a.nav-link {\n      border-width: 0 0 2px 0;\n      border-bottom: 2px solid transparent;\n      color: rgba(0, 0, 0, 0.87);\n      font-family: $fms-font-family;\n      font-size: 18px;\n      font-weight: bold;\n      min-width: 160px;\n      // opacity: 0.6;\n      padding: 7px 24px;\n      text-align: center;\n    }\n\n    a.nav-link.active,\n    a.nav-link:hover {\n      /*border-bottom: 2px solid rgba(0, 0, 0, .87);*/\n    }\n\n    a.nav-link.active {\n      background-color: #fff;\n      color: $fms-blue;\n      border-bottom: 2px solid $fms-blue;\n    }\n  }\n}\n\n.bck-white {\n  background: $fms-white;\n}\n\n.bck-gray {\n  background: $fms-gray-light;\n}\n\n.bck-blue {\n  background: $fms-blue;\n  color: $fms-white;\n}\n\n.bck-blue-light {\n  background: $fms-blue-light;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.white-box {\n  background-color: #fff;\n  padding: 1.5rem;\n}\n\n.blue-box {\n  background-color: $fms-blue-light;\n  padding: 1rem 1.5rem;\n}\n\n.light-gray-box {\n  background-color: $fms-gray-light;\n  padding: 0.75rem;\n}\n\n.card-body {\n  .main-container {\n    padding: 34px;\n  }\n}\n\ninput.rtl {\n  direction: rtl;\n}\n\n.flex-grow {\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  max-width: 100%;\n}\n\n.no-flex-shrink {\n  flex-shrink: 0;\n}\n\n.navbar {\n  z-index: 100;\n}\n\n.pull-right {\n  float: right;\n}\n\n.pull-left {\n  float: left;\n}\n\n.wide-modal {\n  max-width: 60vw !important;\n}\n\n.remove-icon {\n  color: $fms-red;\n  cursor: pointer;\n}\n\n.disabled-icon {\n  color: $fms-gray\n}\n\n.input-group.with-icon {\n  input.form-control {\n    border-right-width: 0;\n  }\n\n  .input-group-text {\n    background-color: #fff;\n  }\n}\n\n.badge.badge-button {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  display: block;\n  min-width: 20px;\n  height: 20px;\n  line-height: 20px;\n  padding: 0 0.4em;\n}\n\na.disabled {\n  pointer-events: none;\n  cursor: not-allowed;\n  opacity: 0.35;\n}\n\n.task-tags {\n  height: 18px;\n  line-height: 0;\n  padding: 0;\n}\n\n.task-tag {\n  height: 18px;\n  font-size: 12px;\n  line-height: 18px;\n  padding: 0 8px;\n  border-radius: 9px;\n  margin-right: 5px;\n}\n\n.task-tag.category {\n  color: $fms-gray;\n  background-color: #e6e9f0;\n}\n\n.task-tag.type {\n  color: #151b26;\n}\n\n.text-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-decoration-underline {\n  text-decoration: underline;\n}\n\n[ng-reflect-router-link] {\n  cursor: pointer;\n}\n\ni-feather.blue-icon {\n  color: $fms-blue;\n  cursor: pointer;\n}\n\ni-feather.white-icon {\n  color: $fms-white;\n  cursor: pointer;\n}\n\n\n.modal-dialog.modal-image {\n  width: auto;\n  max-width: initial;\n\n  .modal-content {\n    width: auto;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 0;\n  }\n}\n\n.float-right {\n  float: right;\n}\n\n\n.color-yellow {\n  color: $fms-yellow;\n}\n\n@keyframes loading-indicator {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-indicator {\n  position: relative;\n}\n\n.loading-indicator .blocker {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  cursor: progress;\n  background-color: rgba(255, 255, 255, 0.7);\n}\n\n.loading-indicator::after {\n  content: '';\n  box-sizing: border-box;\n  position: absolute;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  border-top-color: #07d;\n  border-bottom-color: #07d;\n  animation: .6s linear infinite loading-indicator;\n  z-index: 2;\n}\n\n.loading-indicator.for-dropdown::after {\n  bottom: 6px;\n  right: 6px;\n  width: 20px;\n  height: 20px;\n  background-color: #fff;\n}\n\n.loading-indicator.for-element::after {\n  top: calc(50% - 15px);\n  left: calc(50% - 15px);\n  width: 30px;\n  height: 30px;\n  background-color: transparent;\n}\n\n.star-icon, .star-icon::before {\n  font-size: 1em !important;\n  color: #8291ae !important;\n}\n\n.notifier__container {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\ntable.table {\n  margin-bottom: initial;\n}\n\n.sidenav-content {\n  height: 100%;\n\n  .sidenav-body {\n    padding: 25px 20px;\n    height: calc(100% - 60.5px);\n    overflow-y: auto;\n  }\n\n  .sidenav-footer {\n    border-top: 1px solid rgba(0, 0, 0, 0.125);\n    padding: 12px 20px;\n  }\n}\n\n\n/* structure components styling */\n.Country-list {\n  border-right: solid 1px $fms-blue-light;\n  height: calc(100vh - 215px);\n}\n\n.Country-item {\n  padding-top: 12px;\n  padding-bottom: 12px;\n  font-size: 14px;\n  font-weight: bold;\n  box-shadow: 0 -1px 0 0 $fms-blue-light;\n}\n\n.Country-header {\n  font-size: 18px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  font-weight: bold;\n}\n\n.country-detail-item {\n  color: $fms-white;\n  padding-left: 10px;\n  margin-top: 20px;\n  padding-top: 8px;\n  background: $fms-blue;\n  height: 40px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.governorate-detail-item {\n  padding-left: 10px;\n  margin-top: 10px;\n  padding-top: 8px;\n  color: $fms-blue;\n  background: $fms-blue-secondary;\n  height: 40px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.district-detail-item {\n  padding-left: 10px;\n  margin-top: 10px;\n  padding-top: 8px;\n  color: $fms-blue;\n  background: $fms-blue-light;\n  height: 40px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n\n.unit-detail-item {\n  padding-left: 10px;\n  margin-top: 10px;\n  padding-top: 8px;\n  background: $fms-gray-light;\n  height: 40px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n\nul.org-unit {\n  list-style: none;\n}\n\nul.org-unit li::before {\n  content: \" \";\n  color: $fms-blue;\n  font-size: 0px;\n  /* font-weight: bold; */\n  display: inline-block;\n  position: relative;\n  right: 35px;\n  top: -3px;\n  /* margin-left: 20em; */\n  background: $fms-blue;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n}\n\nul.org-unit li::after {\n  content: \" \";\n  border-left: 1px solid $fms-blue;\n  border-bottom: 1px solid $fms-blue;\n  height: 50px !important;\n  top: -62px;\n  width: 16px;\n  position: relative;\n  display: block;\n  left: -50px;\n}\n\nul.org-unit > ul > li::after {\n  content: \" \";\n  border-left: 1px solid $fms-blue;\n  border-bottom: 1px solid $fms-blue;\n  height: 50px !important;\n  top: -62px;\n  width: 55px;\n  position: relative;\n  display: block;\n  left: -90px;\n}\n\nul.org-unit {\n  margin-bottom: 0 !important;\n}\n\n.no-children {\n  width: 32px;\n  height: 30px;\n}\n\nul.org-unit > ul > ul > li::after {\n  content: \" \";\n  border-left: 1px solid #1161be;\n  border-bottom: 1px solid #1161be;\n  height: 50px !important;\n  top: -62px;\n  width: 95px;\n  position: relative;\n  display: block;\n  left: -130px;\n}\n\nul.org-unit > ul > ul > ul > li::after {\n  content: \" \";\n  border-left: 1px solid #1161be;\n  border-bottom: 1px solid #1161be;\n  height: 50px !important;\n  top: -62px;\n  width: 135px;\n  position: relative;\n  display: block;\n  left: -170px;\n}\n\nul.org-unit > ul > ul > ul > ul > li::after {\n  content: \" \";\n  border-left: 1px solid #1161be;\n  border-bottom: 1px solid #1161be;\n  height: 50px !important;\n  top: -62px;\n  width: 175px;\n  position: relative;\n  display: block;\n  left: -210px;\n}\n\nul.org-unit > ul > ul > ul > ul > ul > li::after {\n  content: \" \";\n  border-left: 1px solid #1161be;\n  border-bottom: 1px solid #1161be;\n  height: 50px !important;\n  top: -62px;\n  width: 215px;\n  position: relative;\n  display: block;\n  left: -250px;\n}\n\nul.org-unit > ul > ul > ul > ul > ul > ul > li::after {\n  content: \" \";\n  border-left: 1px solid #1161be;\n  border-bottom: 1px solid #1161be;\n  height: 50px !important;\n  top: -62px;\n  width: 255px;\n  position: relative;\n  display: block;\n  left: -290px;\n}\n\n.nav-link.country-name {\n  padding: 0;\n}\n\n.country-name-container {\n  list-style-type: none;\n  padding: 0;\n}\n\n.country-name-container a {\n  color: white;\n}\n\n.country-name-container .nav-link {\n  color: #292727;\n}\n","@import \"../../../../styles/custom\";\n\n.inv-request {\n  background: $fms-blue-light;\n  margin-bottom: 5px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  box-shadow: 0 2px 4px 0 #f4f4f4;\n}\n\n.align-center {\n  display: flex;\n  align-items: center;\n  font-family: $fms-font-family;\n  font-size: 16px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n}\n\n.item-delete {\n  direction: rtl;\n}\n\n.buttons {\n  margin-top: 10px;\n  background: white;\n  padding: 5px;\n}\n\n.white-box {\n  padding-top: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
